export enum Shape {
    CREST = 'crest',
    ROUND = 'round',
    SQUARE = 'square'
}

export default Shape;
